import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import { FormControl } from '@mui/material';

import BaseAutocomplete from '../../../../../../../shared/components/base-autocomplete/base-autocomplete';
import BaseRenderInput from '../../../../../../../shared/components/base-autocomplete/components/base-render-input/base-render-input';
import { useAppDispatch } from '../../../../../../../store/hooks';
import { FeaturedEnum } from '../../../../../../shared/enums/featured.enum';
import { mapFeatureEnumToItemLabelModel } from '../../../../../../shared/utils/mapping/mapping.utils';
import { optionEquality } from '../../../../../../shared/utils/option-equality/option-equality.util';
import { filterReviewsByIsFeatured } from '../../../store/slices/slices/reviews.slice';
import { AllReviewsFiltersProps } from '../types/all-reviews-filters-props';
import withFilterValues from './with-filter-values';

const IsFeaturedDropdown: FunctionComponent<AllReviewsFiltersProps> = (
  props: PropsWithChildren<AllReviewsFiltersProps>
): ReactElement => {
  const dispatch = useAppDispatch();

  const { setFieldValue, filterValues } = props;

  const optionsFeatured = [FeaturedEnum.Yes, FeaturedEnum.No].map(
    mapFeatureEnumToItemLabelModel
  );

  return (
    <FormControl
      data-testid="replied-dropdown"
      key="replied-filter"
      classes={{
        root: 'form-control-main',
      }}
    >
      <BaseAutocomplete
        id="replied"
        freeSolo={false}
        multiple={false}
        options={optionsFeatured}
        isOptionEqualToValue={optionEquality}
        value={
          filterValues?.isFeatured === true
            ? optionsFeatured[0]
            : filterValues?.isFeatured === false
            ? optionsFeatured[1]
            : null
        }
        onChange={(event, value) => {
          setFieldValue('isFeatured', value);
          dispatch(filterReviewsByIsFeatured(!!value?.id));
        }}
        renderInput={params => (
          <BaseRenderInput
            {...params}
            id="isFeatured"
            label="Replied"
            name="isFeatured"
            errors={props.errors}
            touched={props.touched}
          />
        )}
      />
    </FormControl>
  );
};

export default withFilterValues(IsFeaturedDropdown);
